import React from 'react';

import { InstructionContent } from './InstructionContent';

const PL: React.FC = () => (
  <div>
    <p className="mb-2">
      Lista pokazuje pozycje mediaplanów z kampanii, dla których kwota zakupu
      różni się od sumy zaakceptowanych, dowiązanych faktur zakupu.
    </p>

    <div className="rounded p-2 mb-2 bg-info bg-opacity-10 border border-info border-opacity-25 d-flex gap-2">
      <span className="text-info fw-semibold flex-shrink-0">💡</span>
      <span>
        Jeśli masz uprawnienie <strong>Kampanie/Projekty</strong> przypisane
        tylko do wybranych zespołów lub budżetów, widzisz wyłącznie pozycje z
        kampanii, do których masz dostęp.
      </span>
    </div>
    <div className="rounded p-2 mb-3 bg-info bg-opacity-10 border border-info border-opacity-25 d-flex gap-2">
      <span className="text-info fw-semibold flex-shrink-0">💡</span>
      <span>
        Jeśli masz uprawnienie <strong>Finanse</strong>, w menu{' '}
        <em>Finanse → Zestawienia finanse</em> masz dostęp do analogicznego
        zestawienia z możliwością eksportu do XLSX.
      </span>
    </div>

    <p className="fw-semibold mb-1">Zakładki</p>
    <ul className="mb-3">
      <li>
        <strong>Profile oprócz TV</strong> — pozycje ze wszystkich profili
        mediaplanów bez TV Zakup.
      </li>
      <li>
        <strong>TV</strong> — pozycje z profilu TV Zakup, dostępne tylko dla
        zespołów z obsługą TV.
      </li>
    </ul>

    <div className="rounded p-2 mb-3 bg-secondary bg-opacity-10 border border-secondary border-opacity-25 d-flex gap-2">
      <span className="flex-shrink-0">ℹ️</span>
      <span>
        Pozycje oznaczone przez administratorów jako{' '}
        <strong>Nie podlega brakom FVZ</strong> nie pojawiają się na żadnej z
        list.
      </span>
    </div>

    <p className="fw-semibold mb-1">Kluczowe kolumny</p>
    <table className="table table-sm table-bordered mb-3 small">
      <thead className="table-light">
        <tr>
          <th>Kolumna</th>
          <th>Znaczenie</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Liczba dni po terminie</td>
          <td>
            Liczba dni od końca raportowanego miesiąca profilu do daty aktualnej
          </td>
        </tr>
        <tr>
          <td>Zakup</td>
          <td>Kwota zakupu dla pozycji mediaplanu</td>
        </tr>
        <tr>
          <td>Suma FVZ</td>
          <td>Kwota z faktur zakupu przypisanych do pozycji</td>
        </tr>
        <tr>
          <td>Do wyjaśnienia</td>
          <td>Różnica: Zakup − Suma FVZ</td>
        </tr>
        <tr>
          <td>Etykieta</td>
          <td>
            Etykieta przedawnienia (kolor zależny od liczby miesięcy):{' '}
            <span className="badge bg-danger bg-opacity-75 me-1">czerwony</span>{' '}
            powyżej 6 m-cy,{' '}
            <span className="badge bg-danger bg-opacity-25 text-dark me-1">
              jasno czerwony
            </span>{' '}
            4–6 m-cy,{' '}
            <span className="badge bg-warning text-dark me-1">
              pomarańczowy
            </span>{' '}
            2–3 m-ce,{' '}
            <span
              className="badge text-dark me-1"
              style={{ backgroundColor: 'rgb(245, 225, 167)' }}
            >
              żółty
            </span>{' '}
            1 m-c.
          </td>
        </tr>
      </tbody>
    </table>

    <p className="fw-semibold mb-1">Widoczne pozycje</p>
    <p className="mb-1">Do raportu zaliczane są pozycje, które:</p>
    <ul className="mb-3">
      <li>
        są przedawnione nie dłużej niż 18 miesięcy i jednocześnie późniejsze od
        początkowego roku i miesiąca określonego w konfiguracji systemu,
      </li>
      <li>
        dotyczą poprzedniego miesiąca kalendarzowego, ale tylko gdy aktualny
        dzień miesiąca jest równy lub późniejszy od dnia 26.
      </li>
    </ul>

    <p className="fw-semibold mb-1">Komentarze</p>
    <ul className="mb-3">
      <li>
        <strong>Komentarz mediaplanera</strong> — dodają i edytują osoby z
        uprawnieniem <strong>Kampanie/Projekty</strong>.
      </li>
      <li>
        <strong>Komentarz finanse</strong> — dodają i edytują osoby z
        uprawnieniem <strong>Finanse</strong>.
      </li>
    </ul>

    <p className="fw-semibold mb-1">Wysyłka przypomnień</p>
    <p className="mb-1">
      Dostępna tylko dla użytkowników z uprawnieniem <strong>Finanse</strong>,
      na dwa sposoby:
    </p>
    <ul className="mb-2">
      <li>
        zaznacz wybrane wiersze i użyj{' '}
        <strong>Wysyłanie przypomnień (N — zaznaczone)</strong>,
      </li>
      <li>
        bez zaznaczania — użyj <strong>Wysyłanie przypomnień</strong> (pozwala
        dodatkowo wybrać zespół i zakres miesięcy).
      </li>
    </ul>
    <p className="mb-2">
      Wiadomość e-mail trafia do wybranych odbiorców (opcjonalnie też na adres
      zespołu) wraz z załącznikiem XLSX zawierającym listę braków fakturowych.
    </p>

    <div className="rounded p-2 bg-warning bg-opacity-10 border border-warning border-opacity-25 d-flex gap-2">
      <span className="flex-shrink-0">⚠️</span>
      <span>
        Na zakładce <strong>TV</strong> przypomnienia można wysłać tylko do
        zespołów obsługujących TV.
      </span>
    </div>
  </div>
);

const EN: React.FC = () => (
  <div>
    <p className="mb-2">
      The list shows media plan positions from campaigns where the purchase
      amount differs from the sum of accepted, linked purchase invoices.
    </p>

    <div className="rounded p-2 mb-2 bg-info bg-opacity-10 border border-info border-opacity-25 d-flex gap-2">
      <span className="text-info fw-semibold flex-shrink-0">💡</span>
      <span>
        If your <strong>Campaigns/Projects</strong> permission is limited to
        specific teams or budgets, you will only see positions from campaigns
        you have access to.
      </span>
    </div>
    <div className="rounded p-2 mb-3 bg-info bg-opacity-10 border border-info border-opacity-25 d-flex gap-2">
      <span className="text-info fw-semibold flex-shrink-0">💡</span>
      <span>
        If you have the <strong>Finance</strong> permission, an equivalent
        report with XLSX export is available under{' '}
        <em>Finance → Finance reports</em>.
      </span>
    </div>

    <p className="fw-semibold mb-1">Tabs</p>
    <ul className="mb-3">
      <li>
        <strong>Profiles except TV</strong> — positions from all media plan
        profiles excluding TV Purchase.
      </li>
      <li>
        <strong>TV</strong> — positions from the TV Purchase profile, available
        only for TV-handling teams.
      </li>
    </ul>

    <div className="rounded p-2 mb-3 bg-secondary bg-opacity-10 border border-secondary border-opacity-25 d-flex gap-2">
      <span className="flex-shrink-0">ℹ️</span>
      <span>
        Positions marked by administrators as{' '}
        <strong>Not subject to purchase invoice gaps</strong> do not appear on
        any list.
      </span>
    </div>

    <p className="fw-semibold mb-1">Key columns</p>
    <table className="table table-sm table-bordered mb-3 small">
      <thead className="table-light">
        <tr>
          <th>Column</th>
          <th>Meaning</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Days overdue</td>
          <td>
            Number of days from the end of the profile's reported month to today
          </td>
        </tr>
        <tr>
          <td>Purchase</td>
          <td>Purchase amount for the media plan position</td>
        </tr>
        <tr>
          <td>Sum of invoices</td>
          <td>Amount from purchase invoices assigned to the position</td>
        </tr>
        <tr>
          <td>To explain</td>
          <td>Difference: Purchase − Sum of invoices</td>
        </tr>
        <tr>
          <td>Label</td>
          <td>
            Overdue label (colour by number of months):{' '}
            <span className="badge bg-danger bg-opacity-75 me-1">red</span> over
            6 months,{' '}
            <span className="badge bg-danger bg-opacity-25 text-dark me-1">
              light red
            </span>{' '}
            4–6 months,{' '}
            <span className="badge bg-warning text-dark me-1">orange</span> 2–3
            months.
          </td>
        </tr>
      </tbody>
    </table>

    <p className="fw-semibold mb-1">Visible positions</p>
    <p className="mb-1">Positions included in the report must:</p>
    <ul className="mb-3">
      <li>
        be overdue by no more than 18 months and later than the start year/month
        defined in system configuration,
      </li>
      <li>
        belong to the previous calendar month, but only when the current day of
        the month is on or after the 26th.
      </li>
    </ul>

    <p className="fw-semibold mb-1">Comments</p>
    <ul className="mb-3">
      <li>
        <strong>Planner comment</strong> — added and edited by users with the{' '}
        <strong>Campaigns/Projects</strong> permission.
      </li>
      <li>
        <strong>Finance comment</strong> — added and edited by users with the{' '}
        <strong>Finance</strong> permission.
      </li>
    </ul>

    <p className="fw-semibold mb-1">Sending reminders</p>
    <p className="mb-1">
      Available only to users with the <strong>Finance</strong> permission, in
      two ways:
    </p>
    <ul className="mb-2">
      <li>
        select rows and use <strong>Send reminders (N — selected)</strong>,
      </li>
      <li>
        without selection — use <strong>Send reminders</strong> (allows choosing
        a team and month range).
      </li>
    </ul>
    <p className="mb-2">
      The e-mail is sent to chosen recipients (optionally also to the team
      address) with an XLSX attachment listing the invoice gaps.
    </p>

    <div className="rounded p-2 bg-warning bg-opacity-10 border border-warning border-opacity-25 d-flex gap-2">
      <span className="flex-shrink-0">⚠️</span>
      <span>
        On the <strong>TV</strong> tab, reminders can only be sent to
        TV-handling teams.
      </span>
    </div>
  </div>
);

export const EstimateItemPurchaseDeficienciesInfo: React.FC = () => (
  <InstructionContent pl={<PL />} en={<EN />} />
);
